/* eslint-disable no-useless-escape */

export function isContainSpecialChar(value: string) {
  const format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  return format.test(value);
}

export function isContainUpper(value: string) {
  return /[A-Z]/.test(value);
}

export function isContainLower(value: string) {
  return /[a-z]/.test(value);
}

export function isNumber(value: string) {
  return /[0-9]/.test(value);
}

export function isOnlyDigits (value: string){
  return /^[0-9]+$/.test(value);
}

//from today onwards
export function isInTheFuture (value: string|Date){
  return new Date(value) > new Date();
}

export function beforeToday(value: string | Date){
  const date = new Date(value);
      date.setDate(date.getDate() + 1);
  return !isInTheFuture(date);
}

export function isBefore(value1:string|Date, value2:string|Date){
return new Date(value1) > new Date(value2)

}

// MED-723 — today as the calendar sees it, "YYYY-MM-DD".
//
// Built from the LOCAL date parts on purpose. `new Date().toISOString()` reports
// the UTC day, which for a West Africa Time user (UTC+1) is still yesterday
// until 01:00 — so a date picker offering "today" would have had it rejected as
// past for the first hour of every day.
export function todayAsDateString() {
  return asLocalDateString(new Date());
}

// A Date read as the calendar day it falls on where the user is, "YYYY-MM-DD".
function asLocalDateString(date: Date) {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

// MED-723 — is `value` on or after the `YYYY-MM-DD` boundary, comparing whole
// calendar days?
//
// A plain string compare, not a Date compare, and that is the entire point. The
// bug this replaces compared a date-only picker value ("2026-09-12", which JS
// parses as UTC midnight) against a full timestamp ("2026-09-12T09:18:53Z"),
// so tomorrow always lost to tomorrow-mid-morning and was rejected as "in the
// past" while two days ahead passed. ISO dates sort lexicographically in date
// order, so comparing the strings is exact, needs no parsing, and cannot drift
// with the caller's timezone or the hour of the day it runs.
//
// Inclusive: a value equal to the boundary is accepted. `isBefore` above is a
// strict `>` and cannot express "on or after", which is why this is separate
// rather than a new argument to it.
export function isNotBeforeDate(value: string | Date, boundary: string) {
  if (!value || !boundary) return true;
  const asDateString =
    typeof value === "string" ? value.slice(0, 10) : asLocalDateString(value);
  return asDateString >= boundary.slice(0, 10);
}

// Validates a Nigerian mobile number in local (0XXXXXXXXXX) or international
// (+234 / 234) format. Self-contained because the `nigeria-phone-number-validator`
// package ships no runtime code (its published tarball is missing the `lib/` dir).
export function isValidNigerianPhoneNumber(value: string) {
  if (!value) return false;
  // Strip common separators (spaces, dashes, parentheses) before matching.
  const normalized = value.replace(/[\s()-]/g, "");
  // 11-digit local numbers start with 0; international numbers use +234/234.
  // The subscriber portion begins with 7, 8 or 9 followed by 9 more digits.
  return /^(\+?234|0)[789]\d{9}$/.test(normalized);
}
